import {endpoints} from './endpoints'
import request from '../request'

export function create(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCompany,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompaniesByUserID(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompaniesByUserID,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanies() {
	return request({
		url: endpoints.getCompanies,
		method: 'get'
	})
}

export function getManageableCompanies() {
	return request({
		url: endpoints.getManageableCompanies,
		method: 'get'
	})
}

export function getCompany(companyId) {
	return request({
		url: `${endpoints.getCompanies}/${companyId}`,
		method: 'get'
	})
}

export function updateCompany(companyId, data) {
	return request({
		url: `${endpoints.getCompanies}/${companyId}`,
		method: 'patch',
		data
	})
}

export function archiveCompany(companyId) {
	return request({
		url: `${endpoints.getCompanies}/${companyId}/archive`,
		method: 'post'
	})
}

export function restoreCompany(companyId) {
	return request({
		url: `${endpoints.getCompanies}/${companyId}/restore`,
		method: 'post'
	})
}